module.exports = __webpack_public_path__ + "img/Wp_2051.5264c536.png";